<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Rubrics Scheme
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2">
                    <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="aylist" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Plaese Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="2">
                    <p><v-icon color="error">*</v-icon><b>Semester</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sem" :items="semlist" item-text="sem" item-value="id" label="Semester" outlined persistent-hint hint="Please Select Semester" />
                </v-col>
                <v-col cols="12" sm="2">
                    <p><v-icon color="error">*</v-icon><b>Standard</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="standard"
                        :items="standard_list"
                        item-text="standard"
                        item-value="id"
                        label="Standard"
                        @change="getCourseOffering(standard)"
                        outlined
                        persistent-hint
                        hint="Please Select Standard"
                    />
                </v-col>
                <v-col cols="12" sm="2">
                    <p><v-icon color="error">*</v-icon><b>Courses</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="subject"
                        :items="subject_list"
                        item-text="course"
                        item-value="id"
                        label="Course"
                        @change="getCourseAssessmentScheme(subject)"
                        outlined
                        persistent-hint
                        hint="Please Select Course"
                    />
                </v-col>
                <v-col cols="12" sm="2" v-if="this.assessmenttypelist.length > 0">
                    <p class="padding-bot"><v-icon color="error">*</v-icon><b>Assessment Type</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="assessmenttype"
                        :items="assessmenttypelist"
                        item-text="assessmenttype"
                        item-value="id"
                        label="Assessment Type"
                        outlined
                        return-object
                        @change="getMarks(assessmenttype)"
                        persistent-hint
                        hint="Please Select Assessment Type"
                    />
                </v-col>
                <v-col cols="12" sm="2" v-if="this.assessmenttypelist.length > 0">
                    <p><v-icon color="error">*</v-icon><b>Assessment Marks</b></p>
                    <v-text-field class="padding-bot" outlined dense type="text" v-model="evaluated_marks" name="evaluated_marks" readonly> </v-text-field>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="showrow">
                <v-btn class="button" @click="fetchRubricsScheme" rounded :loading="loader">Fetch</v-btn>
            </v-row>
        </v-card>
        <v-card class="box" v-if="show_rubrics_card">
            <v-toolbar flat dense>
                <v-toolbar-title>
                    <strong>
                        Rubrics Headers
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2">
                    <p><b>Rubrics Headers</b></p>
                    <!-- <v-autocomplete color="#0F2027" dense rounded required v-model="rubrics_header" :items="rubrics_headers" item-text="name" item-value="id" label="Rubrics Header" outlined /> -->
                    <v-autocomplete color="#0F2027" dense rounded required v-model="rubrics_header" :items="rubrics_headers" item-text="name" return-object label="Rubrics Header" outlined />
                </v-col>
            </v-row>
            <v-card>
                <center>
                    <p><b>Add New Rubrics</b></p>
                </center>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p class="padding-bot"><b>Rubrics</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="rubric" :items="rubrics" item-text="name" return-object item-value="id" label="Rubrics" outlined />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p class="padding-bot"><b>Marks</b></p>
                        <v-text-field class="padding-bot" outlined dense type="text" v-model="marks" name="marks"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="1" lg="1" v-if="hide_plus">
                        <p class="padding-bot"></p>
                        <br />
                        <v-icon @click="addToTempRubicsDetails(rubric,marks,rubrics_header)"> mdi-plus</v-icon>
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="4" lg="4">
                        <v-simple-table v-if="this.temp_rubics_details_1.length > 0">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Sr No.</th>
                                        <th class="text-left">Rubrics Header</th>
                                        <th class="text-left">Rubrics</th>
                                        <th class="text-left">Marks</th>
                                        <th class="text-left">Edit</th>
                                        <th class="text-left">Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,i) in temp_rubics_details_1" :key="i">
                                        <td>{{i+1}}</td>
                                        <td>{{item.rubrics_header_name}}</td>
                                        <td>{{item.name}}</td>
                                        <td>{{item.marks}}</td>
                                        <td><v-icon color="red" @click="editrubric(item,i)">mdi-pencil-circle</v-icon></td>
                                        <td><v-icon color="red" @click="deleterubric(i,item.marks)">mdi-delete-circle</v-icon></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row class="sub-row" justify="center" dense>
                    <v-col cols="12" sm="2">
                        <v-btn class="button" @click="saveRubricsScheme()" rounded :loading="loader" v-if="hide_plus == false">Add</v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-card>
        <v-card class="box" v-if="show_rubrics_details_table && rubrics_details_list!='' && rubricsScheme!=null">
            <template>
                <v-data-table :headers="headers" :items="rubrics_details_list" class="elevation-1 mytable" :search="search" dense v-model="selected" show-select   item-key="id">
                    <template v-slot:top>
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Rurbics Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-toolbar-title>
                                Delete Rurbics Scheme Applied - <span v-for="r,index in rubricsScheme" :key="index">{{ index+1 }})  {{ r }} <span class="pr-2"></span></span> 

                                <v-btn icon @click="deleteRubricshmeneAndDetails()"> <v-icon color="red">mdi-trash-can</v-icon></v-btn>
                            </v-toolbar-title>
                        </v-toolbar>
                        <br>
                    </template>
                    <template v-slot:[`item.edit`]="{ item }">
                        <div>
                            <v-avatar size="25" class="edit-avatar">
                                <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <v-icon color="red" @click="deletedItem(item.id)" :loading="delete_attach_load">mdi-delete-circle</v-icon>
                    </template>
                </v-data-table>
                <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Copy Rurbics Scheme</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-toolbar-title>
                               
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-row dense justify="center">
                            <v-col cols="12" sm="3" md="3" class="pt-5 mt-5" v-if="this.selected!=''">
                                <strong>Total Rubrics Selected - {{ selected.length }}</strong>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <p><v-icon color="error">*</v-icon><b>Standard</b></p>
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    rounded
                                    required
                                    v-model="standard_copy"
                                    :items="standard_list"
                                    item-text="standard"
                                    item-value="id"
                                    label="Standard"
                                    @change="getCourseOfferingCopy(standard_copy)"
                                    outlined
                                    persistent-hint
                                    hint="Please Select Standard"
                                />
                            </v-col>
                        <v-col cols="12" sm="3" md="3">
                            
                    <p><v-icon color="error">*</v-icon><b>Courses</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        multiple
                        v-model="copy_subject"
                        :items="subject_list_copy"
                        item-text="course"
                        item-value="id"
                        label="Course"
                        outlined
                        persistent-hint
                        hint="Please Select Course"
                    />
                </v-col>
                <v-col cols="12" sm="3" md="3" class="pt-5 mt-5">
                <v-btn class="button"  rounded :loading="loader" v-if="subject_list_copy!='' && this.selected!=''" @click="copyRubricsScheme()">Copy Rubrics Scheme</v-btn>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="copied_list!=''">
                    <v-data-table :headers="headers_copy_rubric" :items="copied_list" class="elevation-1 mytable" dense>
                    </v-data-table>
                </v-col>
                </v-row>
            </template>
        </v-card>
        <v-dialog v-model="edit_dialog" max-width="900px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
            <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Edit Rubrics Details
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <!-- <v-container> -->
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="4">
                            <p class="padding-bot"><b>Rubrics</b></p>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="edit.rubric" :items="rubrics" item-text="name" return-object item-value="id" label="Rubrics" outlined />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <p class="padding-bot"><b>Marks</b></p>
                            <v-text-field class="padding-bot" outlined dense type="text" v-model="edit.maxmarks"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="2">
                            <v-btn class="button" @click="saveRubricsDetails()" rounded :loading="loader">Update</v-btn>
                        </v-col>
                    </v-row>
                    <!-- </v-container> -->
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="edit_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        </v-card>
        </v-dialog>
        <v-dialog v-model="editrubric_dialog" max-width="900px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
            <v-card class="box">
                <v-toolbar flat dense>
                    <v-toolbar-title>
                        <strong>
                            Edit Rubrics Details
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="4" lg="4">
                            <p><b>Rubrics</b></p>
                            <v-autocomplete color="#0F2027" dense rounded required v-model="edit_rubric.rubric" readonly :items="rubrics" item-text="name" item-value="id" label="Rubrics" outlined />
                        </v-col>
                        <v-col cols="12" sm="4" lg="4">
                            <p><b>Marks</b></p>
                            <v-text-field class="padding-bot" outlined dense type="text" v-model="edit_rubric.maxmarks"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" lg="4">
                            <p><b></b></p>
                            <v-btn class="button" @click="updaterubricmarks()" rounded :loading="loader">Update</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="editrubric_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            loader: false,
            search: "",
            snackbar_msg: "",
            snackbar: false,
            showrow: false,
            color: "",
            aylist: [],
            ay: "",
            semlist: [],
            sem: "",
            standard_list: [],
            standard: "",
            subject_list: [],
            subject: "",
            assessmenttype: "",
            assessmenttypelist: [],
            evaluated_marks: "",
            rubrics_headers: [],
            copy_subject:[],
            standard_copy:[],
            subject_list_copy:[],
            rubrics_header: null,
            show_rubrics_card: false,
            rubrics: [],
            rubric: null,
            marks: null,
            temp_rubics_details: { id: [], name: [], marks: [] },
            temp_rubics_details_1: [],
            assessment_max_marks: 0,
            hide_plus: true,
            rubrics_details_list: [],
            show_rubrics_details_table: false,
            editrubric_dialog: false,
            total_selected:[],
            selected: [],
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Rubrics Header", value: "rubric_header" },
                { text: "Rubrics", value: "rubric" },
                { text: "Marks", value: "maxmarks" },
                { text: "Edit", value: "edit" },
                { text: "Delete", value: "delete" },
            ],
            edit: {
                rubric: "",
                maxmarks: "",
                rubrics_id: "",
            },
            edit_dialog: false,
            edit_rubric: {
                rubric: "",
                maxmarks: "",
            },
            index: "",
            temp_assessment_max_marks: 0,
            rubricsScheme: null,
            rubricsScheme_id: null,
            delete_attach_load: false,
            copied_list:[],
            headers_copy_rubric: [
                { text: "Course", value: "crs" },
                { text: "Status", value: "status" },
                { text: "Reason", value: "reason" },
            ],
        }),

        mounted() {
            this.onLoad();
        },
        methods: {
            deleteRubricshmeneAndDetails() {
                this.delete_attach_load = true;
                if (!confirm("Are you sure you want to delete Rubrics Scheme And Details...?")) return;
                const formData = {
                    rubricsScheme_id: this.rubricsScheme_id,
                };
                axios
                    .post("/Examination/deleteRubricshmeneAndDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Rubrics Scheme And Details Deleted Successfully"); // show snackbar on success
                            this.show_rubrics_details_table = false;
                            this.fetchRubricsScheme();
                        } 
                        else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.delete_attach_load = false;
                    });
            },
            calculatemaxmarks() {
                (this.assessment_max_marks = 0), (this.temp_assessment_max_marks = 0);
                for (var i = 0; i < this.temp_rubics_details_1.length; i++) {
                    this.temp_assessment_max_marks = this.temp_assessment_max_marks + parseFloat(this.temp_rubics_details_1[i].marks);
                }
                // alert("mmm"+this.temp_assessment_max_marks)
                if (parseFloat(this.evaluated_marks) < parseFloat(this.temp_assessment_max_marks)) {
                    this.showSnackbar("#b71c1c", "Total Marks Should Be Less Than Or Equal To Assessment Marks...!");
                    this.hide_plus = true;
                    return;
                }
                // alert("mmm"+this.temp_assessment_max_marks)
                this.assessment_max_marks = this.temp_assessment_max_marks;
                if (parseFloat(this.evaluated_marks) == parseFloat(this.assessment_max_marks)) {
                    this.hide_plus = false;
                } else {
                    this.hide_plus = true;
                }
            },

            updaterubricmarks() {
                // alert("updaterubricmarks"+this.edit_rubric.maxmarks)
                //alert("index---"+this.index)
                const ind = parseInt(this.index);
                console.log(ind);
                this.temp_rubics_details_1[ind].marks = this.edit_rubric.maxmarks;
                this.editrubric_dialog = false;
                this.calculatemaxmarks();
                return;
            },
            editrubric(item, index) {
                this.editrubric_dialog = true;
                this.edit_rubric.rubric = item.id;
                (this.edit_rubric.maxmarks = item.marks), (this.index = index);
            },
            deleterubric(index, marks) {
                this.temp_rubics_details_1.splice(index, 1);
                // this.assessment_max_marks=parseFloat(this.assessment_max_marks)-parseFloat(marks)
                this.calculatemaxmarks();
            },
            getMarks(item) {
                this.evaluated_marks = item.evaluated_marks;
                return;
            },
            deletedItem(item) {
                const formData = {
                    rubrics_detail_id: item,
                };
                axios
                    .post("/Examination/deleteRubricsDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.fetchRubricsScheme()
                           // this.rubrics_details_list = res.data.rubrics_details_list;
                            this.showSnackbar("#4caf50", "Deleted Successfully...!");
                        }
                        else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            saveRubricsDetails() {
                const formData = {
                    rubrics_details_id: this.edit.rubrics_id,
                    rubric: this.edit.rubric,
                    maxmarks: this.edit.maxmarks,
                    // rubric:"",maxmarks:"",rubrics_id:""
                };
                axios
                    .post("/Examination/saveRubricsDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                           // this.rubrics_details_list = res.data.rubrics_details_list;
                            this.edit_dialog = false;
                            this.fetchRubricsScheme()
                            this.showSnackbar("#4caf50", "Updated Successfully...!");
                        } else if (res.data.flag == "No") {
                           // this.rubrics_details_list = res.data.rubrics_details_list;
                            this.showSnackbar("red", res.data.snackbar);
                            this.fetchRubricsScheme()
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            editItem(item) {
                const formData = {
                    rubrics_detail_id: item.id,
                };
                axios
                    .post("/Examination/editRubricsDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            //this.edit.rubric=res.data.id
                            this.edit.rubric = res.data.rubrics_id;
                            this.edit.maxmarks = res.data.maxmarks;
                            this.edit.rubrics_id = res.data.id;
                            this.edit_dialog = true;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            async copyRubricsScheme(){
                this.loader = true;
                for (var i = 0; i < this.selected.length; i++) {
                    this.total_selected.push(this.selected[i].id);
                }
                const data = {
                    course: this.subject,
                    ay: this.ay,
                    sem: this.sem,
                    assessmenttype: this.assessmenttype.id,
                    copy_subject : this.copy_subject,
                    rubrics:this.total_selected
                };
                try {
                    const res = await axios.post("/Examination/copyRubricsScheme", data);
                    if (res.data.flag == "YES") {
                        this.copied_list = res.data.copied_list
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                    this.loader = false;
                } finally {
                    this.loader = false;
                    this.selected = [],
                    this.total_selected=[]
                    this.copy_subject = []
                    this.standard_copy = []
                }
            },
            saveRubricsScheme() {
                const formData = {
                    course: this.subject,
                    ay: this.ay,
                    sem: this.sem,
                    assessmenttype: this.assessmenttype.id,
                   // rubrics_header: this.rubrics_header,
                    rubics_details: this.temp_rubics_details_1,
                };
                this.loader = true;
                axios
                    .post("/Examination/saveRubricsScheme", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Saved Successfully...!");
                            (this.show_rubrics_card = false), 
                            //(this.rubrics_details_list = res.data.rubrics_details_list);
                            this.fetchRubricsScheme()
                            this.loader = false;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                        this.rubrics_header = null;
                     //   this.temp_rubics_details_1 = []
                        this.rubric = null
                    });
            },

            addToTempRubicsDetails(name, marks,rubrics_header) {
                //  alert("name"+name)
                //alert("marks"+marks)

                if (this.rubrics_header == "" || this.rubrics_header == null) {
                    this.showSnackbar("#b71c1c", "Please Select Rubrics Header...!");
                    return;
                }

                if (name == "" || name == null) {
                    this.showSnackbar("#b71c1c", "Please Select Rubrics...!");
                    return;
                }
                if (marks == "" || marks == null) {
                    this.showSnackbar("#b71c1c", "Please Enter Marks...!");
                    return;
                }
                // for (var i = 0; i < this.temp_rubics_details_1.length; i++) {
                //     if (this.temp_rubics_details_1[i].name == name.name) {
                //         this.showSnackbar("#b71c1c", "Rubric Already Added...!");
                //         return;
                //     }
                // }

                this.temp_rubics_details = { id: name.id, name: name.name, marks: marks,rubrics_header_id:rubrics_header.id,rubrics_header_name:rubrics_header.name };
                //  this.rubrics=this.rubrics.splice(name)

                this.temp_rubics_details_1.push(this.temp_rubics_details);
                //   this.temp_rubics_details.name.push(name.name)
                //   this.temp_rubics_details.marks.push(marks)
                //   this.temp_rubics_details.id.push(name.id)
                this.assessment_max_marks = parseFloat(marks) + parseFloat(this.assessment_max_marks);
                this.marks = "";
                if (parseFloat(this.evaluated_marks) == parseFloat(this.assessment_max_marks)) {
                    // alert("true")
                    this.hide_plus = false;
                }
                return;
            },
            fetchRubricsScheme() {
                this.rubrics_details_list = [];
                this.show_rubrics_card = false;
                this.rubrics_headers = [];
                //this.rubrics_header = null
                this.rubrics = [];
                this.temp_rubics_details_1 = [];
                this.assessment_max_marks = 0;
                this.rubricsScheme = null;
                this.hide_plus = true;
                if (this.assessmenttype == "" || this.assessmenttype == null) {
                    this.showSnackbar("#b71c1c", "Please Select Assessment Type ...!");
                    return;
                }

                const formData = {
                    course: this.subject,
                    ay: this.ay,
                    sem: this.sem,
                    assessmenttype: this.assessmenttype.id,
                    evaluated_marks: this.evaluated_marks,
                };
                axios
                    .post("/Examination/fetchRubricsScheme", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.rubrics_details_list = res.data.rubrics_details_list;
                            if (this.rubrics_details_list.length == 0) {
                                this.show_rubrics_card = true;
                            }
                            this.show_rubrics_details_table = true;
                            this.rubrics_headers = res.data.rubrics_headers;
                            this.rubrics = res.data.rubrics;
                            (this.rubricsScheme = res.data.rubricsScheme), (this.rubricsScheme_id = res.data.rubricsScheme_id);
                        } else if (res.data.flag == "No") {
                            this.rubrics_headers = res.data.rubrics_headers;
                            this.rubrics = res.data.rubrics;
                            this.show_rubrics_card = true;
                            this.rubricsScheme = res.data.rubricsScheme;
                            this.rubricsScheme_id = res.data.rubricsScheme_id;
                        } else if (res.data.flag == "NA") {
                            this.rubrics_details_list = res.data.rubrics_details_list;
                            this.show_rubrics_details_table = true;
                            this.rubrics_headers = res.data.rubrics_headers;
                            this.rubrics = res.data.rubrics;
                            this.show_rubrics_card = true;
                            this.addToTempRubicsDetails_1();
                            this.rubricsScheme = res.data.rubricsScheme;
                            this.rubricsScheme_id = res.data.rubricsScheme_id;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            addToTempRubicsDetails_1() {
                //alert("in addtorubric::")
               // console.log(this.rubrics_details_list)
                for (var i = 0; i < this.rubrics_details_list.length; i++) {
                    //alert(this.rubrics_details_list[i].id)
                    this.temp_rubics_details = { id: this.rubrics_details_list[i].rubric_id, 
                                                 name: this.rubrics_details_list[i].rubric, 
                                                 marks: parseFloat(this.rubrics_details_list[i].maxmarks),
                                                 rubrics_header_id:this.rubrics_details_list[i].rubric_header_id,
                                                 rubrics_header_name:this.rubrics_details_list[i].rubric_header
                                                };
                    this.temp_rubics_details_1.push(this.temp_rubics_details);
                    this.assessment_max_marks += parseFloat(this.rubrics_details_list[i].maxmarks);
                }
                return this.temp_rubics_details_1;
            },

            getCourseAssessmentScheme(course) {
                // alert("standard::"+standard)
                const formData = {
                    course: course,
                    ay: this.ay,
                    sem: this.sem,
                };
                axios
                    .post("/Examination/getCourseAssessmentScheme", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.assessmenttypelist = res.data.assessment_type_list;
                            if (this.assessmenttypelist.length == 0) {
                                this.showSnackbar("#b71c1c", "Course Assessment Scheme Not Found...!");
                                return;
                            }
                            //  this.evaluated_marks=res.data.evaluated_marks
                            this.showrow = true;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            getCourseOfferingCopy(standard_copy){
                const formData = {
                    standard: standard_copy,
                    ay: this.ay,
                    sem: this.sem,
                };
                axios
                    .post("/Examination/getCourseOfferings", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.subject_list_copy = res.data.course_list;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            getCourseOffering(standard) {
                // alert("standard::"+standard)
                const formData = {
                    standard: standard,
                    ay: this.ay,
                    sem: this.sem,
                };
                axios
                    .post("/Examination/getCourseOfferings", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.subject_list = res.data.course_list;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            onLoad() {
                axios
                    .post("/Examination/getInitialData")
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.aylist = res.data.ay_list;
                            this.semlist = res.data.sem_list;
                            this.standard_list = res.data.standard_list;
                            this.ay = res.data.curreny_ay;
                            //this.ay=res.data.ay_list.current_ay
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped></style>
